import React from 'react';
import {
  Box,
  Typography,
  Paper,
  Button,
  ToggleButtonGroup,
  ToggleButton,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from '@mui/material';
import {
  LocalShipping,
  Settings,
  InfoOutlined,
  AssessmentOutlined,
  DescriptionOutlined,
  TodayOutlined,
  DateRangeOutlined,
  CheckCircleOutline,
  StorefrontOutlined,
  PublicOutlined
} from '@mui/icons-material';

const OrderFormContainer = ({
  theme,
  printType,
  handleOpenPrintTypeModal,
  filter,
  setFilter,
  channelFilter,
  setChannelFilter,
  channelsData,
  pagination,
}) => {
  return (
    <Paper
      elevation={0}
      sx={{
        mb: { xs: 1.5, md: 2 },
        p: { xs: 2.5, sm: 3, md: 4 },
        borderRadius: { xs: 3, md: 4 },
        position: "relative",
        background: "linear-gradient(135deg, #ffffff 0%, #fffbf0 50%, #fff8e1 100%)",
        backdropFilter: "blur(10px)",
        border: "1px solid rgba(255, 152, 0, 0.2)",
        boxShadow: "0 20px 60px rgba(255, 152, 0, 0.1), 0 0 0 1px rgba(255, 255, 255, 0.8)",
        "&::before": {
          content: '""',
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          height: "4px",
          background: "linear-gradient(90deg, #ff9800 0%, #ffc107 50%, #ff9800 100%)",
          borderRadius: "4px 4px 0 0"
        }
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 3,
          flexWrap: "wrap",
          gap: 2
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
          <Box
            sx={{
              width: 40,
              height: 40,
              borderRadius: "50%",
              background: "linear-gradient(135deg, #ff9800 0%, #ffc107 100%)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              boxShadow: "0 4px 12px rgba(255, 152, 0, 0.3)"
            }}
          >
            <LocalShipping sx={{ color: "white", fontSize: "1.5rem" }} />
          </Box>
          <Box>
            <Typography
              variant="h5"
              sx={{
                fontWeight: 800,
                background: "linear-gradient(135deg, #ff9800 0%, #f57c00 100%)",
                backgroundClip: "text",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                letterSpacing: "0.5px"
              }}
            >
              Impressão de Etiquetas
            </Typography>
            <Typography
              variant="body2"
              color="text.secondary"
              sx={{ fontWeight: 500, mt: 0.5 }}
            >
              Gestão de pedidos e etiquetas
            </Typography>
          </Box>
        </Box>
        
        <Box 
          sx={{ 
            display: "flex", 
            alignItems: "center", 
            gap: 2,
            bgcolor: "rgba(255, 152, 0, 0.08)",
            borderRadius: 3,
            px: 2,
            py: 1.5,
            border: "1px solid rgba(255, 152, 0, 0.2)"
          }}
        >
          <Typography
            variant="body2"
            color="warning.dark"
            fontWeight={600}
            sx={{ fontSize: "0.9rem" }}
          >
            Modo:
          </Typography>
          <Button
            variant="contained"
            color="warning"
            size="small"
            onClick={handleOpenPrintTypeModal}
            sx={{ 
              fontWeight: 700, 
              borderRadius: 2,
              textTransform: "none",
              boxShadow: "0 4px 12px rgba(255, 152, 0, 0.3)",
              "&:hover": {
                boxShadow: "0 6px 16px rgba(255, 152, 0, 0.4)"
              }
            }}
          >
{printType === "detalhada" ? (
              <>
                <Settings sx={{ fontSize: "1rem", mr: 0.5 }} />
                Detalhada
              </>
            ) : (
              <>
                <Settings sx={{ fontSize: "1rem", mr: 0.5 }} />
                Simples
              </>
            )}
          </Button>
        </Box>
      </Box>
      
      
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          justifyContent: "space-between",
          alignItems: { xs: "flex-start", md: "center" },
          mb: 3,
          gap: { xs: 1.5, md: 2 },
          p: 2,
          borderRadius: 2,
          bgcolor: "rgba(255, 152, 0, 0.05)",
          border: "1px solid rgba(255, 152, 0, 0.1)"
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
          <Box
            sx={{
              width: 32,
              height: 32,
              borderRadius: "50%",
              bgcolor: "warning.main",
              display: "flex",
              alignItems: "center",
              justifyContent: "center"
            }}
          >
            <InfoOutlined sx={{ color: "white", fontSize: "1.2rem" }} />
          </Box>
          <Typography
            variant="body1"
            color="text.primary"
            fontWeight={500}
            sx={{ fontSize: { xs: "0.9rem", md: "1rem" } }}
          >
            Selecione um pedido pendente para visualizar e imprimir a etiqueta
          </Typography>
        </Box>
        
        <Box 
          sx={{
            display: "flex", 
            gap: 3, 
            alignItems: "center",
            flexWrap: "wrap",
            bgcolor: "white",
            borderRadius: 2,
            px: 2,
            py: 1,
            border: "1px solid rgba(255, 152, 0, 0.2)"
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <AssessmentOutlined sx={{ fontSize: "1.1rem", color: "warning.main" }} />
            <Typography 
              variant="body2" 
              color="text.secondary"
              sx={{ fontSize: { xs: "0.8rem", md: "0.9rem" }, fontWeight: 500 }}
            >
              Total: <strong>{pagination.total_items || 0}</strong>
            </Typography>
          </Box>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <DescriptionOutlined sx={{ fontSize: "1.1rem", color: "success.main" }} />
            <Typography 
              variant="body2" 
              color="success.main" 
              fontWeight={700}
              sx={{ fontSize: { xs: "0.8rem", md: "0.9rem" } }}
            >
              {pagination.current_page}/{pagination.total_pages}
            </Typography>
          </Box>
        </Box>
      </Box>
      
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", sm: "row" },
          gap: { xs: 2, md: 3 },
          alignItems: { xs: "stretch", sm: "center" },
        }}
      >
        <ToggleButtonGroup
          value={filter}
          exclusive
          onChange={(_, val) => val && setFilter(val)}
          sx={{
            background: "linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)",
            borderRadius: 3,
            boxShadow: "0 8px 25px rgba(255, 152, 0, 0.15)",
            width: { xs: "100%", sm: "auto" },
            display: "flex",
            flexWrap: { xs: "wrap", sm: "nowrap" },
            border: "1px solid rgba(255, 152, 0, 0.2)",
            overflow: "hidden",
            "& .MuiToggleButton-root": {
              fontSize: { xs: "0.75rem", sm: "0.85rem", md: "0.9rem" },
              px: { xs: 1, sm: 2, md: 2.5 },
              py: { xs: 1, md: 1.2 },
              flex: { xs: "1 1 auto", sm: "0 1 auto" },
              minWidth: { xs: "auto", sm: "unset" },
              fontWeight: 600,
              textTransform: "none",
              border: "none !important",
              position: "relative",
              transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
              "&.Mui-selected": {
                background: "linear-gradient(135deg, #ff9800 0%, #f57c00 100%)",
                color: "white",
                boxShadow: "0 4px 12px rgba(255, 152, 0, 0.4)",
                "&:hover": {
                  background: "linear-gradient(135deg, #f57c00 0%, #ef6c00 100%)"
                }
              },
              "&:not(.Mui-selected)": {
                "&:hover": {
                  background: "rgba(255, 152, 0, 0.1)"
                }
              }
            }
          }}
          color="warning"
          orientation="horizontal"
        >
          <ToggleButton value="today">
            <TodayOutlined sx={{ fontSize: "1rem", mr: 0.5 }} />
            Pendentes Hoje
          </ToggleButton>
          <ToggleButton value="before">
            <DateRangeOutlined sx={{ fontSize: "1rem", mr: 0.5 }} />
            Pendentes Anteriores
          </ToggleButton>
          <ToggleButton value="printed">
            <CheckCircleOutline sx={{ fontSize: "1rem", mr: 0.5 }} />
            Impressos
          </ToggleButton>
        </ToggleButtonGroup>

        <FormControl 
          size="small" 
          sx={{ 
            minWidth: { xs: "100%", sm: 160, md: 200 },
            maxWidth: { xs: "100%", sm: 220 }
          }}
        >
          <InputLabel 
            sx={{ 
              fontWeight: 600,
              color: "warning.main",
              "&.Mui-focused": {
                color: "warning.main"
              }
            }}
          >
            <StorefrontOutlined sx={{ fontSize: "1rem", mr: 0.5 }} />
            Canal
          </InputLabel>
          <Select
            value={channelFilter}
            label="Canal"
            onChange={(e) => setChannelFilter(e.target.value)}
            sx={{
              borderRadius: 3,
              background: "linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)",
              boxShadow: "0 4px 12px rgba(255, 152, 0, 0.1)",
              border: "1px solid rgba(255, 152, 0, 0.2)",
              "& .MuiOutlinedInput-notchedOutline": {
                border: "none"
              },
              "&:hover .MuiOutlinedInput-notchedOutline": {
                border: "none"
              },
              "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                border: "2px solid #ff9800"
              },
              "& .MuiSelect-select": {
                fontWeight: 600,
                fontSize: { xs: "0.85rem", md: "0.9rem" }
              }
            }}
          >
            <MenuItem value="all" sx={{ fontWeight: 600 }}>
              <PublicOutlined sx={{ fontSize: "1rem", mr: 1 }} />
              Todos os Canais
            </MenuItem>
            {channelsData?.data?.map((channel) => (
              <MenuItem 
                key={channel.id} 
                value={channel.channel}
                sx={{ fontWeight: 500 }}
              >
                <StorefrontOutlined sx={{ fontSize: "1rem", mr: 1 }} />
                {channel.name || channel.channel}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>
    </Paper>
  );
};

export default OrderFormContainer;